module.exports = __webpack_public_path__ + "img/Banner.7e2e501e.jpg";